// import { env } from '@hb/NBridge/lib/h5';

const routes = [
  {
    path: '/tw-card-active',
    name: 'tw-card-active',
    meta: {
      title: '哈啰骑行福利',
    },
    component: () => import('@/pages/tw-card-active/index'),
  },
  {
    path: '/newClient',
    name: 'newClient',
    meta: {
      title: '新客权益',
      hideNavBar: true,
    },
    component: () => import('@/pages/newClient/index'),
  },
  {
    path: '/coupon-exchange',
    name: 'coupon-exchange',
    meta: { title: '卡券兑换' },
    component: () => import('@/pages/coupon-exchange/index'),
  },
  {
    path: '/coupon-exchange-v2',
    name: 'coupon-exchange-v2',
    meta: {
      title: '卡券兑换',
      hideNavBar: true,
    },
    component: () => import('@/pages/coupon-exchange-v2/index'),
  },
  {
    path: '/coupon-exchange-v2-new',
    name: 'coupon-exchange-v2-new',
    meta: {
      title: '卡券兑换',
      hideNavBar: true,
    },
    component: () => import('@/pages/coupon-exchange-v2/index-new'),
  },
  {
    path: '/student-center',
    name: 'student-center-index',
    meta: { title: '学生中心', login: { enable: true, mode: 'replace' } },
    component: () => import('@/pages/student-center/index'),
  },
  {
    path: '/vip',
    name: 'vip',
    meta: {
      title: '付费会员',
      hideNavBar: true,
    },
    component: () => import('@/pages/vip/index'),
  },
  // {
  //   path: '/vip/v2',
  //   name: 'vip-v2',
  //   meta: {
  //     title: '出行省钱会员',
  //     hideNavBar: true,
  //   },
  //   component: () => import('@/pages/vip/v2/index'),
  // },
  // {
  //   path: '/vip/v2/open',
  //   name: 'vip-v2/open',
  //   meta: {
  //     title: '出行省钱会员',
  //     hideNavBar: true,
  //   },
  //   component: () => import('@/pages/vip/v2/open'),
  // },
  {
    path: '/vip/newTransfer',
    name: 'super-new-member-transfer',
    meta: {
      title: '超级会员',
      hideNavBar: true,
    },
    component: () => import('@/pages/vip/super/newTransfer'),
  },
  {
    path: '/vip/v3',
    name: 'super-new-member',
    meta: {
      title: '超级会员',
      hideNavBar: true,
    },
    component: () => import('@/pages/vip/super/newVersion'),
  },
  {
    path: '/vip/v2/open',
    name: 'super-member',
    meta: {
      title: '超级会员',
      hideNavBar: true,
    },
    component: () => import('@/pages/vip/super/index'),
  },
  {
    path: '/vip/v2',
    name: 'super-member/open',
    meta: {
      title: '超级会员',
      hideNavBar: true,
    },
    component: () => import('@/pages/vip/super/open'),
  },
  {
    path: '/vip/v2/middle',
    name: 'super-middle/open',
    meta: {
      title: '超级会员',
      hideNavBar: true,
    },
    component: () => import('@/pages/vip/super/middle'),
  },
  {
    path: '/vip/open',
    name: 'vip-open',
    meta: {
      title: '付费会员',
      hideNavBar: true,
    },
    component: () => import('@/pages/vip/open'),
  },
  {
    path: '/vip/history',
    name: 'vip-history',
    meta: {
      title: '付费会员',
      hideNavBar: true,
    },
    component: () => import('@/pages/vip/history'),
  },
  {
    path: '/vip/transfer',
    name: 'vip-transfer',
    meta: {
      title: '超级会员',
      hideNavBar: true,
    },
    component: () => import('@/pages/vip/transfer'),
  },
  {
    path: '/vip/v2/transfer',
    name: 'vip-v2-transfer',
    meta: {
      title: '超级会员',
      hideNavBar: true,
    },
    component: () => import('@/pages/vip/v2/transfer'),
  },
  {
    path: '/vip/super/components/qa',
    name: 'vip-super-qa',
    meta: {
      title: '超级会员',
      hideNavBar: false,
    },
    component: () => import('@/pages/vip/super/components/qa'),
  },
  {
    path: '/vip/super/auto-renew',
    name: 'vip-auto-renew',
    meta: {
      title: '自动续费管理',
      hideNavBar: true,
    },
    component: () => import('@/pages/vip/super/auto-renew'),
  },
  {
    path: '/vip/history-detail',
    name: 'vip-history-detail',
    meta: {
      title: '付费会员',
      hideNavBar: true,
    },
    component: () => import('@/pages/vip/history-detail'),
  },
  {
    path: '/student-center/base',
    name: 'student-center-base',
    meta: { title: '学生中心' },
    component: () => import('@/pages/student-center/base'),
  },
  {
    path: '/student-center/success',
    name: 'student-center-success',
    meta: { title: '学生中心' },
    component: () => import('@/pages/student-center/success'),
  },
  {
    path: '/bounty',
    name: 'Bounty',
    meta: {
      title: '',
      hideNavBar: true,
      keepAlive: true, // 卡券商城改动：需要缓存页面
      deepth: 1, // 卡券商城改动：页面层级
      // !! 非常重要这个页面会做为卡券商城的首页，所以路由beforeEach会处理该路由添加query参数
      source: 'couponMall', // 卡券商城改动：页面来源
      // !! 卡券商城改动：接口登录超时103，H5、微信小程序需要跳转到本项目中的h5登录页
      login: { enable: true, mode: 'push' },
    },
    // component: env.isAliMP || env.isAliMPMonitor
    //   ? () => import('@/pages/welfare/welfare-new')
    //   : () => import('@/pages/welfare/welfare'),
    component: () => import('@/pages/welfare/index'),
  },
  {
    // 卡券商城支付回调再用该路由，勿修改
    path: '/welfare-center',
    name: 'WelfareCenter',
    meta: {
      title: '',
      hideNavBar: true,
      keepAlive: true, // 卡券商城改动：需要缓存页面
      deepth: 1, // 卡券商城改动：页面层级
      // !! 非常重要这个页面会做为卡券商城的首页，所以路由beforeEach会处理该路由添加query参数
      source: 'couponMall', // 卡券商城改动：页面来源
      // !! 卡券商城改动：接口登录超时103，H5、微信小程序需要跳转到本项目中的h5登录页
      login: { enable: true, mode: 'push' },
    },
    // component: env.isAliMP || env.isAliMPMonitor
    //   ? () => import('@/pages/welfare/welfare-new')
    //   : () => import('@/pages/welfare/welfare'),
    component: () => import('@/pages/welfare/welfare-center'),
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '哈啰' },
    component: () => import('@/pages/login/index'),
  },
  {
    path: '/bounty/exchange',
    name: 'bounty-exchange',
    meta: { title: '我的奖励金' },
    component: () => import('@/pages/welfare/exchange/index'),
  },
  {
    path: '/custom-push',
    name: 'custom-push',
    meta: { title: '个性化推荐设置管理' },
    component: () => import('@/pages/custom-push/index'),
  },
  {
    path: '/ant-forest/transfer',
    name: 'ant-forest-transfer',
    component: () => import('@/pages/ant-forest/transfer'),
  },
  {
    path: '/ant-forest/new-my-page',
    name: 'ant-forest-new-my-page',
    component: () => import('@/pages/ant-forest/newMyPage'),
  },
  {
    path: '/ant-forest/success',
    name: 'ant-forest-success',
    meta: { title: '蚂蚁森林能量说明' },
    component: () => import('@/pages/ant-forest/success'),
  },
  {
    path: '/ant-forest/record',
    name: 'ant-forest-record',
    meta: { title: '蚂蚁森林能量明细' },
    component: () => import('@/pages/ant-forest/record'),
  },
  {
    path: '/ant-forest/auth',
    name: 'ant-forest-auth',
    meta: { title: '开通蚂蚁森林能量' },
    component: () => import('@/pages/ant-forest/auth'),
  },
  {
    path: '/discount',
    name: 'discount',
    meta: { title: 'APP骑行随机立减' },
    component: () => import('@/pages/discount/index'),
  },
  {
    path: '/bounty/detail/:id',
    name: 'bounty-detail',
    meta: { title: '商品详情' },
    component: () => import('@/pages/bounty/detail'),
  },
  {
    path: '/bounty/record',
    name: 'bounty-record',
    meta: { title: '我的奖励金' },
    component: () => import('@/pages/bounty/record'),
  },
  {
    path: '/welfare/bonus-rule',
    name: 'welfare-bonus-rule',
    meta: {
      title: '开通奖励金自动抵扣',
      hideNavBar: true,
    },
    component: () => import('@/pages/welfare/bonus-rule'),
  },
  {
    path: '/welfare/meal-sleep-subsidy',
    name: 'welfare-meal-sleep-subsidy',
    meta: {
      title: '吃饭睡觉补贴活动详情',
      hideNavBar: true,
    },
    component: () => import('@/pages/welfare/meal-sleep-subsidy/index'),
  },
  {
    path: '/welfare/withdraw',
    name: 'welfare-withdraw',
    meta: {
      title: '福利中心提现',
      hideNavBar: true,
    },
    component: () => import('@/pages/welfare-withdraw/index'),
  },
  {
    path: '/card-for-app',
    name: 'card-for-app',
    meta: { title: 'APP骑行更优惠' },
    component: () => import('@/pages/card-for-app/index'),
  },
  // {
  //   path: '/card-for-c',
  //   name: 'card-for-c',
  //   meta: {
  //     title: '',
  //     hideNavBar: true,
  //   },
  //   component: () => import('@/pages/card-for-app/card-for-c'),
  // },
  {
    path: '/card-for-app-success',
    name: 'card-for-app-success',
    meta: { title: '' },
    component: () => import('@/pages/card-for-app/success'),
  },
  {
    path: '/card-for-app-successC',
    name: 'card-for-app-successC',
    meta: { title: '' },
    component: () => import('@/pages/card-for-app/page-c/components/success.vue'),
  },
  {
    path: '/member',
    name: 'member',
    meta: { title: '会员中心' },
    component: () => import('@/pages/member/index'),
  },
  {
    path: '/member/rights',
    name: 'memberRights',
    meta: { title: '会员中心' },
    component: () => import('@/pages/member/rights'),
  },
  {
    path: '/wechat-mp-card',
    name: 'wechat-mp-card',
    meta: { title: '哈啰' },
    redirect: (from) => ({ path: '/wechat-mp-card-uni', query: { version: 1, ...from.query } }),
  },
  {
    path: '/wechat-mp-card-new',
    name: 'wechat-mp-card-new',
    meta: { title: '哈啰' },
    redirect: (from) => ({ path: '/wechat-mp-card-uni', query: { version: 2, ...from.query } }),
  },
  {
    path: '/wechat-mp-card-uni',
    name: 'wechat-mp-card-uni',
    meta: { title: '哈啰' },
    component: () => import('@/pages/wechat-mp-card-uni/index'),
  },
  {
    path: '/wechat-mp-card-new/card',
    name: 'wechat-mp-card-new/card',
    meta: { title: '哈啰' },
    component: () => import('@/pages/wechat-mp-card-new/card'),
  },
  {
    path: '/member/detail',
    name: 'memberDetail',
    meta: { title: '会员中心' },
    component: () => import('@/pages/member/detail'),
  },
  {
    path: '/sesame-go',
    name: 'sesame-go',
    meta: {
      title: '芝麻go',
      hideNavBar: true,
    },
    component: () => import('@/pages/sesame-go/index'),
  },
  {
    path: '/collect-coupons',
    name: 'collect-coupons',
    meta: {
      title: '天天有好券',
      hideNavBar: true,
    },
    component: () => import('@/pages/collect-coupons/index'),
  },
  {
    path: '/update-card',
    name: 'update-card',
    meta: {
      title: '升级卡券',
      hideNavBar: true,
    },
    component: () => import('@/pages/update-card/index'),
  },
  {
    path: '/mgm',
    name: 'mgm',
    meta: {
      title: '',
      hideNavBar: true,
    },
    component: () => import('@/pages/mgm/index'),
  },
  {
    path: '/mgm/success',
    name: 'mgm/success',
    meta: {
      title: '',
      hideNavBar: true,
    },
    component: () => import('@/pages/mgm/components/success'),
  },
  {
    path: '/mgm/rule',
    name: 'mgm/rule',
    meta: {
      title: '活动规则',
      hideNavBar: false,
    },
    component: () => import('@/pages/mgm/components/rule'),
  },
  {
    path: '/collect-coupons',
    name: 'collect-coupons',
    meta: {
      title: '天天有好券',
      hideNavBar: true,
    },
    component: () => import('@/pages/collect-coupons/index'),
  },
  {
    path: '/collect-coupons',
    name: 'collect-coupons',
    meta: {
      title: '天天有好券',
      hideNavBar: true,
    },
    component: () => import('@/pages/collect-coupons/index'),
  },
  {
    path: '/personal-info',
    name: 'personal-info',
    meta: {
      title: '个人信息与隐私管理',
    },
    component: () => import('@/pages/personal-info/index'),
  },
  {
    path: '/system-permission',
    name: 'system-permission',
    meta: {
      title: '系统权限管理',
    },
    component: () => import('@/pages/system-permission/index'),
  },
  {
    path: '/scan',
    name: 'scan',
    meta: { title: '哈啰', login: { enable: true, mode: 'replace' } },
    component: () => import('@/pages/scan/index'),
  },
  {
    path: '/reunion',
    name: 'reunion',
    meta: {
      title: '团圆',
      hideNavBar: true,
    },
    component: () => import('@/pages/reunion/index'),
  },
  {
    path: '/reunion/detail',
    name: 'reunionDetail',
    meta: {
      title: '案件详情',
      hideNavBar: true,
    },
    component: () => import('@/pages/reunion/detail'),
  },
  {
    path: '/wechat-control/bike',
    name: 'wechat-control-bike',
    meta: {
      title: '骑行优惠',
      hideNavBar: false,
    },
    component: () => import('@/pages/wechat-control/bike'),
  },
  {
    path: '/wechat-control/ride',
    name: 'wechat-control-ride',
    meta: {
      title: '',
      hideNavBar: false,
    },
    component: () => import('@/pages/wechat-control/ride'),
  },
  {
    path: '/feedback',
    name: 'feedback',
    meta: {
      title: '搜索满意度调研',
      hideNavBar: false,
    },
    component: () => import('@/pages/feedback/index'),
  },
  {
    path: '/personalInfoCollectionList',
    name: 'personalInfoCollectionListIndex',
    meta: {
      title: '个人信息收集清单',
    },
    component: () => import('@/pages/personalInfoCollectionList/index'),
  },
  {
    path: '/personalInfoCollectionList/:sectionType',
    name: 'personalInfoCollectionListSectionPage',
    meta: {
      title: '个人信息详情',
    },
    component: () => import('@/pages/personalInfoCollectionList/components/InfoSection.vue'),
    props: (route) => ({
      sectionType: route.params.sectionType,
    }),
  },
  {
    path: '/appSizePage',
    name: 'appSizePage',
    meta: {
      title: '哈啰',
      hideNavBar: false,
    },
    component: () => import('@/pages/appSizePage/index'),
  },
  {
    path: '/vip/v3/lotteryRecord',
    name: 'super-lottery-record',
    meta: {
      title: '0元抽免单 每天20点开奖',
      hideNavBar: true,
    },
    component: () => import('@/pages/vip/super/lotteryRecord'),
  },
  {
    path: '/jumpApp',
    name: 'jumpApp',
    meta: {
      title: '哈啰',
      hideNavBar: false,
    },
    component: () => import('@/pages/jump-app/index'),
  },
  {
    path: '/testSuper',
    name: 'testSuper',
    meta: {
      title: '哈啰',
      hideNavBar: false,
    },
    component: () => import('@/pages/testSuper/index'),
  },
  {
    path: '/passwordFreePay',
    name: 'passwordFreePay',
    meta: {
      hideNavBar: true,
    },
    component: () => import('@/pages/passwordFreePay/index'),
  },
  {
    path: '/dev-routes',
    name: 'dev-routes',
    meta: {
      title: '开发路由导航',
      hideNavBar: true,
    },
    component: () => import('@/pages/dev-routes/index'),
  },
  {
    path: '/t-landing',
    name: 't-landing',
    meta: {
      title: '哈啰换电',
      hideNavBar: true,
    },
    component: () => import('@/pages/t-landing/index'),
  },
  {
    path: '/tw-card-active/get-reward',
    name: 'get-reward',
    meta: {
      title: '哈啰换电',
      hideNavBar: true,
    },
    component: () => import('@/pages/tw-card-active/getReward.vue'),
  },
  // -- 卡券商城路由 start --
  {
    path: '/mall',
    name: 'Mall',
    component: () => import('@/pages/mall/pages/mallList/index.tsx'),
    meta: {
      keepAlive: true,
      deepth: 1,
      source: 'couponMall',
      login: { enable: true, mode: 'push' },
      hideNavBar: true,
    },
  },
  {
    path: '/TicketDetail',
    name: 'TicketDetail',
    component: () => import('@/pages/mall/pages/mallDetail/index.tsx'),
    meta: {
      source: 'couponMall',
      login: { enable: true, mode: 'push' },
      hideNavBar: true,
    },
  },
  {
    path: '/TicketPayResult',
    name: 'TicketPayResult',
    component: () => import('@/pages/mall/pages/payResult/TicketPayResult.vue'),
    meta: {
      source: 'couponMall',
      hideNavBar: true,
    },
  },
  {
    path: '/order',
    name: 'OrderList',
    component: () => import('@/pages/mall/pages/order/list/index.vue'),
    meta: {
      keepAlive: true,
      keepAliveName: 'MallOrder',
      deepth: 2,
      source: 'couponMall',
      login: { enable: true, mode: 'push' },
      hideNavBar: true,
    },
  },
  {
    path: '/order/:orderId',
    name: 'orderDetail',
    component: () => import('@/pages/mall/pages/order/detail/OrderDetail.vue'),
    meta: {
      source: 'couponMall',
      login: { enable: true, mode: 'push' },
      hideNavBar: true,
    },
  },
  {
    path: '/order/orderAfterSale/:orderId',
    name: 'orderAfterSale',
    component: () => import('@/pages/mall/pages/order/afterSale/index.vue'),
    meta: {
      source: 'couponMall',
      login: { enable: true, mode: 'push' },
      hideNavBar: true,
    },
  },
  {
    path: '/refundOrder',
    name: 'refundOrder',
    component: () => import('@/pages/mall/pages/order/refundOrder/index.vue'),
    meta: {
      source: 'couponMall',
      login: { enable: true, mode: 'push' },
      hideNavBar: true,
    },
  },
  {
    path: '/couponFreeCompose',
    name: 'CouponFreeCompose',
    component: () => import('@/pages/mall/pages/couponFreeCompose/index.tsx'),
    meta: {
      clearKeepAlive: true,
      source: 'couponMall',
      hideNavBar: true,
    },
  },
  {
    path: '/payAfterUse',
    name: 'PayAfterUse',
    component: () => import('@/pages/mall/pages/payAfterUse/index.tsx'),
    meta: {
      source: 'couponMall',
      login: { enable: true, mode: 'push' },
      hideNavBar: true,
    },
  },
  // -- 卡券商城路由 end --
  {
    path: '*',
  },
];

export default routes;
